@if (
  label &&
  showLabel &&
  inputType !== 'switch' &&
  inputType !== 'dropdown' &&
  inputType !== 'phone'
  ) {
  <label
    [attr.for]="inputId"
    [ngClass]="
      labelClass ||
      'mb-2'
    "
  >
    <span
      [ngClass]="
        labelClass
          ? ''
          : 'fw-medium fs-6 text-nowrap'
      "
    >
      {{ label | translate }}
    </span>
  </label>
}

@if (inputType === 'switch') {
  <div
    class="
      d-flex
      form-switch
      justify-content-between
      mb-1
    "
  >
    <label
      class="
        form-check-label
        fs-6
      "
      [for]="inputId"
    >
      {{ label | translate }}
    </label>

    <input
      class="
        form-check-input
        switch-success
      "
      type="checkbox"
      [id]="inputId"
      [checked]="value()"
      [disabled]="disabled()"
      (change)="onSwitchChange($event)"
    />
  </div>
}

@if (inputType === 'dropdown') {
  <div
    class="position-relative"
    [ngClass]="inputClass"
  >
    @if (
      label &&
      showLabel
      ) {
      <label
        [for]="inputId"
        class="
          form-label
          fs-6
        "
      >
        {{ label | translate }}
      </label>
    }

    <button
      type="button"
      class="
        form-control
        lib-input__dropdown-toggle
        d-flex
        align-items-center
        justify-content-between
        gap-lg-2
        text-start
      "
      [ngClass]="
        dropdownToggleClass
      "
      [id]="inputId"
      [disabled]="disabled()"
      [class.is-invalid]="
        myControl?.touched &&
        myControl?.errors
      "
      [attr.aria-expanded]="
        dropdownOpen
      "
      aria-haspopup="listbox"
      (click)="toggleDropdown()"
      (keydown.escape)="
        closeDropdown()
      "
    >
      <div
        class="
          d-flex
          align-items-center
          flex-grow-1
          overflow-hidden
          text-start
        "
      >
        @if (
          getSelectedItem();
          as selectedItem
          ) {
          @if (
            selectedItemTemplate
            ) {
            <ng-container
              *ngTemplateOutlet="
                selectedItemTemplate;
                context: {
                  $implicit:
                    selectedItem
                }
              "
            >
            </ng-container>
          } @else {
            <span
              class="
                d-block
                text-truncate
              "
            >
              {{
                selectedItem[
                labelKey ||
                'name'
                  ] | translate
              }}
            </span>
          }
        } @else {
          <span
            class="
              d-block
              text-truncate
              text-body-secondary
            "
          >
            {{
              placeholder
                | translate
            }}
          </span>
        }
      </div>

      <i
        class="
          flex-shrink-0
          fs-5
        "
        aria-hidden="true"
        [ngClass]="
          dropdownOpen
            ? 'icon-chevron-up'
            : 'icon-chevron-down'
        "
      >
      </i>
    </button>

    @if (dropdownOpen) {
      <ul
        class="
          dropdown-menu
          dropdown-menu-adaptive
          show
          position-absolute
          mt-2
          p-0
          shadow
          fs-7
        "
        [class.dropdown-menu-align-end]="
          dropdownAlign ===
          'inline-end'
        "
        [ngClass]="
          dropdownMenuClass
        "
        role="listbox"
      >
        @for (
          item of
          items ?? [];
          track
            item[
            valueKey || 'id'
              ]
          ) {
          <li>
            <button
              type="button"
              class="
                dropdown-item
                p-0
                d-flex
                align-items-center
                w-100
              "
              role="option"
              [attr.aria-selected]="
                isItemSelected(
                  item
                )
              "
              [class.active]="
                isItemSelected(
                  item
                )
              "
              (click)="
                selectItem(item)
              "
            >
              @if (
                itemTemplate
                ) {
                <ng-container
                  *ngTemplateOutlet="
                    itemTemplate;
                    context: {
                      $implicit:
                        item,
                      selected:
                        isItemSelected(
                          item
                        )
                    }
                  "
                >
                </ng-container>
              } @else {
                <span
                  class="
                    d-block
                    p-3
                    text-truncate
                  "
                >
                  {{
                    item[
                    labelKey ||
                    'name'
                      ] | translate
                  }}
                </span>
              }
            </button>
          </li>
        }
      </ul>
    }
  </div>
}

@if (inputType === 'phone') {
  <div
    class="position-relative"
    [ngClass]="inputClass"
  >
    <input
      type="tel"
      dir="ltr"
      maxlength="11"
      class="form-control"
      [ngClass]="
        controlClass
      "
      [id]="inputId"
      [placeholder]="
        placeholder ||
        '09xxxxxxxxx'
      "
      [disabled]="disabled()"
      [readonly]="isReadonly"
      [attr.inputmode]="
        inputMode || 'tel'
      "
      [class.is-invalid]="
        myControl?.touched &&
        myControl?.errors
      "
      [value]="phoneNumber"
      (input)="
        onIranPhoneInput(
          $event
        )
      "
      (blur)="onBlur()"
    />
  </div>
}

@if (
  inputType !== 'switch' &&
  inputType !== 'dropdown' &&
  inputType !== 'phone'
  ) {
  @if (!inputTemplate) {
    @if (group) {
      <div
        class="input-group"
        dir="ltr"
        [ngClass]="inputClass"
      >
        <span
          class="
            input-group-text
            bg-body
            text-body-secondary
          "
          [ngClass]="
            groupTextClass
          "
        >
          {{ group | translate }}
        </span>

        @if (
          inputType === 'price'
          ) {
          <input
            class="form-control"
            dir="ltr"
            priceInput
            (blur)="onBlur()"
            (input)="
              onInput($event)
            "
            [ngClass]="
              controlClass
            "
            [autocomplete]="
              autocomplete ||
              'off'
            "
            [disabled]="
              disabled()
            "
            [readonly]="
              isReadonly
            "
            [attr.inputmode]="
              inputMode ||
              'decimal'
            "
            [id]="inputId"
            [class.is-invalid]="
              myControl?.touched &&
              myControl?.errors
            "
            [placeholder]="
              showPlaceHolder &&
              (
                label ||
                placeholder
              )
                ? placeholder
                  ? (
                      placeholder
                        | translate
                    )
                  : (
                      label
                        | translate
                    ) +
                    ' ' +
                    (
                      'COMMON.Enter'
                        | translate
                    )
                : ''
            "
            [type]="inpType"
            [value]="
              value() ===
              undefined
                ? inputValue ||
                  ''
                : value()
            "
          />
        } @else {
          <input
            class="form-control"
            dir="ltr"
            [class.text-body-secondary]="isMaskEmpty()"
            (blur)="onBlur()"
            (input)="
              onInput($event)
            "
            [ngClass]="
              controlClass
            "
            [autocomplete]="
              autocomplete ||
              'off'
            "
            [disabled]="
              disabled()
            "
            [readonly]="
              isReadonly
            "
            [attr.inputmode]="
              inputMode
            "
            [id]="inputId"
            [class.is-invalid]="
              myControl?.touched &&
              myControl?.errors
            "
            [placeholder]="
              showPlaceHolder &&
              (
                label ||
                placeholder
              )
                ? placeholder
                  ? (
                      placeholder
                        | translate
                    )
                  : (
                      label
                        | translate
                    ) +
                    ' ' +
                    (
                      'COMMON.Enter'
                        | translate
                    )
                : ''
            "
            [type]="inpType"
            [value]="
              value() ===
              undefined
                ? inputValue ||
                  ''
                : value()
            "
          />
        }
      </div>
    } @else {
      <div
        class="position-relative"
        [ngClass]="inputClass"
      >
        @if (
          inputType !==
          'text-area' &&
          inputType !== 'price'
          ) {
          <input
            class="form-control"
            [class.text-body-secondary]="isMaskEmpty()"
            [ngClass]="
              controlClass
            "
            (blur)="onBlur()"
            (input)="
              onInput($event)
            "
            [autocomplete]="
              autocomplete ||
              'off'
            "
            [disabled]="
              disabled()
            "
            [readonly]="
              isReadonly
            "
            [attr.inputmode]="
              inputMode
            "
            [id]="inputId"
            [class.is-invalid]="
              myControl?.touched &&
              myControl?.errors
            "
            [class.has-end-action]="
              !!iconClass ||
              inputType ===
                'password'
            "
            [placeholder]="
              showPlaceHolder &&
              (
                label ||
                placeholder
              )
                ? placeholder
                  ? (
                      placeholder
                        | translate
                    )
                  : (
                      label
                        | translate
                    ) +
                    ' ' +
                    (
                      'COMMON.Enter'
                        | translate
                    )
                : ''
            "
            [type]="inpType"
            [value]="
              value() ===
              undefined
                ? inputValue ||
                  ''
                : value()
            "
          />
        }

        @if (
          inputType === 'price'
          ) {
          <input
            class="form-control"
            [ngClass]="
              controlClass
            "
            (blur)="onBlur()"
            (input)="
              onInput($event)
            "
            [autocomplete]="
              autocomplete ||
              'off'
            "
            [disabled]="
              disabled()
            "
            [readonly]="
              isReadonly
            "
            [attr.inputmode]="
              inputMode ||
              'decimal'
            "
            [id]="inputId"
            [class.is-invalid]="
              myControl?.touched &&
              myControl?.errors
            "
            [class.has-end-action]="
              !!iconClass
            "
            [placeholder]="
              showPlaceHolder &&
              (
                label ||
                placeholder
              )
                ? placeholder
                  ? (
                      placeholder
                        | translate
                    )
                  : (
                      label
                        | translate
                    ) +
                    ' ' +
                    (
                      'COMMON.Enter'
                        | translate
                    )
                : ''
            "
            [type]="inpType"
            [value]="
              value() ===
              undefined
                ? ''
                : value()
            "
            priceInput
          />
        }

        @if (
          inputType ===
          'password'
          ) {
          <button
            type="button"
            class="
              btn
              border-0
              position-absolute
              top-50
              translate-middle-y
              input-end-action
              p-2
              lh-1
              text-body-secondary
              z-1
            "
            [disabled]="
              disabled()
            "
            aria-label="
              Toggle password visibility
            "
            (click)="
              showPassword()
            "
          >
            @if (
              IconPassword
              ) {
              <span
                class="
                  icon-eye
                  fs-4
                "
                aria-hidden="
                  true
                "
              >
              </span>
            } @else {
              <span
                class="
                  icon-eye-crossed
                  fs-4
                "
                aria-hidden="
                  true
                "
              >
              </span>
            }
          </button>
        } @else if (
          iconClass
          ) {
          <span
            class="
              position-absolute
              top-50
              translate-middle-y
              input-end-action
              p-2
              text-body-secondary
              pe-none
              z-1
            "
          >
            <i
              class="lh-1"
              [ngClass]="
                iconClass
              "
              aria-hidden="
                true
              "
            >
            </i>
          </span>
        }
      </div>
    }

    @if (
      inputType ===
      'text-area'
      ) {
      <textarea
        class="form-control"
        [ngClass]="controlClass"
        (blur)="onBlur()"
        (input)="onInput($event)"
        [disabled]="disabled()"
        [readonly]="isReadonly"
        [id]="inputId"
        [class.is-invalid]="
          myControl?.touched &&
          myControl?.errors
        "
        [placeholder]="
          showPlaceHolder &&
          (
            label ||
            placeholder
          )
            ? placeholder
              ? (
                  placeholder
                    | translate
                )
              : (
                  label
                    | translate
                ) +
                ' ' +
                (
                  'COMMON.Enter'
                    | translate
                )
            : ''
        "
        [value]="
          value() === undefined
            ? ''
            : value()
        "
        rows="5"
      >
      </textarea>
    }
  } @else {
    <ng-container
      *ngTemplateOutlet="
        inputTemplate
      "
    >
    </ng-container>
  }
}

@if (
  myControl?.touched &&
  myControl?.errors
  ) {
  <ul
    class="
      list-unstyled
      text-danger
      p-0
      mb-0
      fs-8
      mt-1
    "
  >
    @if (
      myControl?.errors?.[
        'required'
        ]
      ) {
      <li>
        {{
          'VALIDATION.Required'
            | translate
            : {
              label:
                (
                  label
                    | translate
                )
            }
        }}
      </li>
    }

    @if (
      myControl?.errors?.[
        'maxlength'
        ]
      ) {
      <li>
        {{
          'VALIDATION.MaxLength'
            | translate
            : {
              label:
                (
                  label
                    | translate
                ),
              max:
              myControl
                ?.errors?.[
                'maxlength'
                ]
                .requiredLength
            }
        }}
      </li>
    }

    @if (
      myControl?.errors?.[
        'minlength'
        ]
      ) {
      <li>
        {{
          'VALIDATION.MinLength'
            | translate
            : {
              label:
                (
                  label
                    | translate
                ),
              min:
              myControl
                ?.errors?.[
                'minlength'
                ]
                .requiredLength
            }
        }}
      </li>
    }

    @if (
      !myControl
        ?.errors?.[
        'required'
        ] &&
      inputType ===
      'email' &&
      (
        myControl
          ?.errors?.[
          'email'
          ] ||
        myControl
          ?.errors?.[
          'pattern'
          ]
      )
      ) {
      <li>
        {{
          'VALIDATION.Email'
            | translate
        }}
      </li>
    }

    @if (
      !myControl
        ?.errors?.[
        'required'
        ] &&
      inputType !==
      'email' &&
      myControl
        ?.errors?.[
        'pattern'
        ]
      ) {
      <li>
        {{
          'VALIDATION.Pattern'
            | translate
            : {
              label:
                (
                  label
                    | translate
                )
            }
        }}
      </li>
    }

    @if (
      myControl?.errors?.[
        'max'
        ]
      ) {
      <li>
        {{
          'VALIDATION.Max'
            | translate
            : {
              max:
              myControl
                ?.errors?.[
                'max'
                ].max
            }
        }}
      </li>
    }
  </ul>
}

@if (showErrorPassword) {
  @if (
    inputType ===
    'password' &&
    (
      myControl?.touched ||
      myControl?.dirty
    ) &&
    !(
      myControl?.errors?.[
        'required'
        ]
    )
    ) {
    <ul
      class="
        mt-2
        ps-4
        fs-8
      "
    >
      <li
        [class.text-danger]="
          myControl
            ?.errors?.[
            'minLength'
          ]
        "
        [class.text-success]="
          !myControl
            ?.errors?.[
            'minLength'
          ]
        "
      >
        {{
          'VALIDATION.Minimum8Characters'
            | translate
        }}
      </li>

      <li
        [class.text-danger]="
          myControl
            ?.errors?.[
            'hasLowerCase'
          ]
        "
        [class.text-success]="
          !myControl
            ?.errors?.[
            'hasLowerCase'
          ]
        "
      >
        {{
          'VALIDATION.AtLeastOneLowerCaseLetter'
            | translate
        }}
      </li>

      <li
        [class.text-danger]="
          myControl
            ?.errors?.[
            'hasUpperCase'
          ]
        "
        [class.text-success]="
          !myControl
            ?.errors?.[
            'hasUpperCase'
          ]
        "
      >
        {{
          'VALIDATION.AtLeastOneCapitalLetter'
            | translate
        }}
      </li>

      <li
        [class.text-danger]="
          myControl
            ?.errors?.[
            'hasNumeric'
          ]
        "
        [class.text-success]="
          !myControl
            ?.errors?.[
            'hasNumeric'
          ]
        "
      >
        {{
          'VALIDATION.AtLeastOneDigit'
            | translate
        }}
      </li>

      <li
        [class.text-danger]="
          myControl
            ?.errors?.[
            'hasSpecialChars'
          ]
        "
        [class.text-success]="
          !myControl
            ?.errors?.[
            'hasSpecialChars'
          ]
        "
      >
        {{
          'VALIDATION.UsingTheSymbol'
            | translate
        }}
      </li>

      <li
        [class.text-danger]="
          myControl
            ?.errors?.[
            'withoutSpace'
          ]
        "
        [class.text-success]="
          !myControl
            ?.errors?.[
            'withoutSpace'
          ]
        "
      >
        {{
          'VALIDATION.NoSpaces'
            | translate
        }}
      </li>
    </ul>
  }
}
